import { useState, useRef } from "react";
import Config from "../../Config";
import PlTitle from "../../elements/PlTitle";
import InputTextAlpha from "../../helpers/InputTextAlpha";
import InputComboSubkonto from "../../helpers/InputComboSubkonto";
import InputPagger from "../../helpers/InputPagger";
import InputLegend from "../../helpers/InputLegend";
import FormatDecimal from "../../helpers/FormatDecimal";
import InputCombo from "../../helpers/InputCombo";
import HtmlToPDF from "../../exporter/HtmlToPDF";
import Csv from "../../exporter/Csv";
import Print from "../../exporter/Print";
import InputDecimal from "../../helpers/InputDecimal";
import CalculateEdit from "./CalculateEdit";
import SortBy from "../../helpers/SortBy";

import edit from "../../edit.png";
import gopresent from "../../gopresent.png";
import MenuTable from "../../helpers/MenuTable";
import InvoiceSplit from "./CalculateSplit";

import search from "../../search.png";
import InputDate from "../../helpers/InputDate";
import CalculateTrans from "./CalculateTrans";
import CalculateMove from "./CalculateMove";
import AppContext from "../../AppContext";
import Xlsx from "../../exporter/Xlsx";


function Calculate(props)
{


    const [refreshView, setRefreshView] = useState(props.userData.refreshView);


    const [filterParam, setFilterParam] = useState({

        saldo_typ: '_x_',

        d_imie_nazwisko: props.mainView.readFilter('d_imie_nazwisko',''), 
        r_imie_nazwisko: props.mainView.readFilter('r_imie_nazwisko',''), 
      

        p_grupa_id: props.mainView.readFilter('p_grupa_id','_x_'), 
        
        p_subkonta_id: props.mainView.readFilter('p_subkonta_id','_x_'),  
 

        kwota_od: '',
        kwota_do: '',

        data_od: '',
        data_do: '',

        strona: '_x_',


        sortBy: {
            sort:  "", //asc desc,
            column: "",
        },
    
     
        limit: 50,
        page: 1,
        pages: 1,
        show: true,

    });
    const [tab, setTab] = useState(null);
    const [selectedRow, setSelectedRow] = useState([]);

    const tabRef = useRef(0); //do druku
    const tab2Ref = useRef(0); //do druku

    const [view, setView] = useState ( {
        v:'list',
        id: -1
    } );


    const [legend, setLegend] = useState([
        {
            cls:'color_show2',
            title: 'pozycja rozliczona'
        },
    ]);





           
    const changeView = (e ) => {
        var v = e.target.getAttribute('v');
        var id = e.target.getAttribute('id');

        setView({...view, ["v"]:v, ["id"]:id });
    }


    const onBack = (e) => {

        setView({...view, ["v"]:"list", ["id"]:"-1" }); 
        getTab();
        
    }

    const reviewKid = (e) =>
        {
            var id        = e.target.getAttribute("id");
            var imie      = e.target.getAttribute("imie");
            var nazwisko  = e.target.getAttribute("nazwisko");
    
            props.mainView.openKid( id, imie, nazwisko );
        }



        //-------------------------------------------------------
//-------------------------------------------------------
//MASS
const changeSelected = (e) => {

    var id    = e.target.getAttribute('atr-id');   
    var selected = 0;

    if(e.target.checked) selected = 1;

    for(var k=0; k<selectedRow.length; k++)
    {
        if(selectedRow[k].id == id)  selectedRow[k].selected = selected;
    }

    setSelectedRow(  JSON.parse(JSON.stringify(selectedRow) ) );    
}

const changeSelectedAll = (e) => {

    var s = selectedRow[0].selected;
    if(s == 1) {  s = 0; } else s = 1;

    for(var k=0; k<selectedRow.length; k++)
        {
          selectedRow[k].selected = s;
        }
    
        setSelectedRow(  JSON.parse(JSON.stringify(selectedRow) ) ); 

}


//-------------------------------------------------------

const searchParent = (e) => {

    var search = e.target.getAttribute("search");
    //alert(search);

    setFilterParam( {...filterParam, ["r_imie_nazwisko"]:search,  ["r_imie_nazwisko_valid"]:true } );
    setTab(null);
}

const searchKid = (e) => {

    var search = e.target.getAttribute("search");
    //alert(search);

    setFilterParam( {...filterParam, ["d_imie_nazwisko"]:search,  ["d_imie_nazwisko_valid"]:true } );
    setTab(null);
}

//-------------------------------------------------------


   
    const getTab = () => {
            
        
        props.mainView.setProgress(-2);
    

        fetch( Config.url + '/rest_v1_calc,calculate', {
            method: 'POST', 
            body: JSON.stringify(filterParam), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
        })
        .then(res => res.json() )
        .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setTab(res.result);  

                        var newSelector = [];

                        res.result.forEach( (item) => {
                            newSelector.push({
                                id: item.id,
                                title: item.opis,             
                                typ: item.typ,              
                                data: item.data,                           
                                kwota: item.kwota,    
                                kwota_rozliczenia: item.kwota_rozliczenia,    
                                pozostalo: item.pozostalo,                                   
                                selected: 0,
                            });
                            
                        } )

                        setSelectedRow(newSelector);

                        if(res.pages != undefined )setFilterParam( {...filterParam,   ['pages']: res.pages  } );             
                    }
        } )
        .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
        });
                

        return false;
    }





    const valChangeListener = (filedName, val, correct, msg) => {

        // console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);

        setFilterParam( {...filterParam, [filedName]:val,  [filedName+"_valid"]:correct } );
        
        if(   (val.length == 0 || val.length > 2 || msg =='combo')  && filterParam[filedName] != val )
            {
                    var defTimeOut = 1000;
                    if(msg == 'combo') defTimeOut = 10;
                    clearTimeout(AppContext.timeoutId);
                    AppContext.timeoutId = setTimeout( () => {
                        setTab(null); 
                    } , defTimeOut );
            }

        props.mainView.writeFilter(filedName, val);
    }


    const goNextNew = () => {
        console.log("goNext");    
        setTab(null);    
    }


    const filterView = () => {
        setFilterParam(  {...filterParam, ["show"]:!filterParam.show } );
    }

    const filterClear = () => {

        props.mainView.writeFilter('d_imie_nazwisko', '');
        props.mainView.writeFilter('r_imie_nazwisko', '');
      
        props.mainView.writeFilter('p_group_id', '_x_'); 

     
   

        setFilterParam({

            saldo_typ: '_x_',

            d_imie_nazwisko: '', 
            r_imie_nazwisko: '', 
                 
            p_grupa_id: '_x_',        
            strona: '_x_',        

            data_od: '',        
            data_do: '',        
            
          

            p_subkonta_id: '_x_',    

            kwota_od: '',
            kwota_do: '',


            sortBy: {
                sort:  "", //asc desc,
                column: "",
            },
                                       
            limit: 50,
            page: 1,
            show: true,
        });
        setTab(null);
    }

    const filterApprove = () => {   
        setTab(null)     
    }

    const onChangePagger = (x_limit, x_page) => {

        setFilterParam(  {...filterParam, ["limit"]:x_limit, ["page"]:x_page} );
        setTab(null);
    }


    const onChangeSortBy = (sortBy) => {

        setFilterParam(  {...filterParam, ["sortBy"]:sortBy } );
        setTab(null);
    }






    const goBack = () => {

        setView( {
            v:'list',
            id: -1
        });

    }

    const onSuccess = () => {
        
        setView( {
            v:'list',
            id: -1
        });

        getTab();
    }



    const moveBack =  (e) => {

        var id = e.target.getAttribute('id');

     


        props.mainView.showDialog("Potwierdź", "Czy na pewno chcesz cofnąć przeniesienie środków?", "yesno", (option)=>{
          
            ///--------
            if(option == "yes") goMoveBack(id);
            //--------
        } );

    }

    const goMoveBack = (id) => {

        /*
        var tabX = new Array();
    
        for(var k=0; k < tab.length; k++)
        {
            if(tab[k].id == id )
            {
                tabX =   tab[k];                        
            }
        }*/


        props.mainView.setProgress(-2);

        var req = {
            id:id
        };

        fetch( Config.url + '/rest_v1_calc,calc_split_back', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                       props.mainView.showDialog( "Sukces",  "Operacja wykonana sukcesem." , "ok" , null);  
                       getTab();  
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                

    }




        if(tab == null)
        {
            setTab([]);
            getTab();
        
    
            return <div>
                ...
            </div>
        }
    
    
        if(refreshView != props.userData.refreshView)
        {         
            setRefreshView( props.userData.refreshView);
            setTab(null);
            setView( {
                v:'list',
                id: -1
            });
        }


        if(view.v == 'edit')
            {          
                var tmpId = -999;

                for(var k=0; k < tab.length; k++)
                {
                    if(tab[k].id == view.id)
                    {
                        tmpId = tab[k].id;
                        break;
                    }
                }

                return <CalculateEdit   userData={props.userData}  mainView={props.mainView} p_saldo_ma_wn_id={tmpId} goBack={goBack} onSuccess={onSuccess}  />
            }

            if(view.v == 'move')
                {          
                    var tabX = new Array();
    
                    for(var k=0; k < tab.length; k++)
                    {
                        if(tab[k].id == view.id)
                        {
                            tabX =   tab[k];
                            console.log("WWW", tab[k] );
                            break;
                        }
                    }
    
                    return <CalculateMove   userData={props.userData}  mainView={props.mainView} row={tabX} goBack={goBack} onSuccess={onSuccess}  />
                }


                



    var itemsTyp = [
        {  v: '_x_',    title: '- - - '   },
        {  v: 'f',    title: 'Faktury'   },
        {  v: 'fnr',    title: 'Faktury nierozliczone'   },
        {  v: 'fnrt',    title: 'Faktury nierozliczone (po terminie)'   },
        {  v: 'fr',    title: 'Faktury rozliczone'   },
        {  v: 'o',    title: 'Odsetki'   },
        {  v: 'onr',    title: 'Odsetki nierozliczone'   },
        {  v: 'or',    title: 'Odsetki rozliczone'   },
        {  v: 'p',    title: 'Przelewy lub zwroty'   },
        {  v: 'pnr',    title: 'Przelewy lub zwroty nierozliczone'   },
        {  v: 'pr',    title: 'Przelewy lub zwroty rozliczone'   },        
        {  v: 'dr',    title: 'Wszystkie rozliczone'   },
        {  v: 'dnr',    title: 'Wszystkie nierozliczone'   },
    ];




    var sortList = [                
        {column: "kwota", name: "Kwota"  }, 
        {column: "kwota_rozliczenia", name: "Kwota rozliczenia"  }, 
        {column: "pozostalo_x", name: "Pozostało"  }, 
        {column: "data", name: "Data"  },        
        {column: "rodzic_nazwisko", name: "Rodzic"  },
        {column: "dziecko_nazwisko", name: "Dziecko"  },
 
    ]




    var itemsStrona = [
        {v: '_x_', title: '- - - '},
        {v: 'ma', title: 'Uznania (MA)'},
        {v: 'wn', title: 'Obciążenia (WN)'},
    ];



    var razemKwota = 0;
    var razemKwotaRozliczenia = 0;
    var razemPozostalo = 0;

    var HrazemKwota = 0;
    var HrazemKwotaRozliczenia = 0;
    var HrazemPozostalo = 0;




    var zaznaczonych = 0;
    var arrSelected = new Array();       
    var arrSelectedToRem = new Array();       
    var arrSelectedToRem2 = new Array();       
    for(var s=0; s<selectedRow.length; s++)
    {
        if(selectedRow[s].selected == 1) 
        {
            zaznaczonych ++;
            arrSelected.push( selectedRow[s] ); 
            
            if(selectedRow[s].kwota_rozliczenia != 0) 
            {
                arrSelectedToRem.push( selectedRow[s] ); 
            }

            arrSelectedToRem2.push( selectedRow[s] ); 
        }
    }


    return <div className="view_content">
 

                <div className="bg_center">

                {
                    filterParam.show == false  &&
                    <div className="  goright link_color" onClick={filterView}>
                        pokaż filtry
                    </div>
                } 


                {
                    filterParam.show == true  &&
                    <div className="table_filter">


                    <div className="filter_controll">   
                                    <label>Strona: </label>                             
                                    <InputCombo items={itemsStrona} userData={props.userData}  mainView={props.mainView}  value={filterParam.strona}   valChange={valChangeListener} goNext={goNextNew} name="strona" placeholder={" "}   />
                    </div> 



                    <div className="filter_controll">   
                                    <label>Subkonto: </label>                             
                                    <InputComboSubkonto userData={props.userData}  mainView={props.mainView}  value={filterParam.p_subkonta_id}   valChange={valChangeListener} goNext={goNextNew} name="p_subkonta_id" placeholder={" "}   />
                                </div> 


                    <div className="filter_controll">   
                            <label>Rodzaj wpisu na saldzie: </label>                             
                            <InputCombo  items={itemsTyp} userData={props.userData}  mainView={props.mainView}  value={filterParam.saldo_typ}   valChange={valChangeListener} goNext={goNextNew} name="saldo_typ" placeholder={": "}   />
                        </div> 

           

                                            
                               
                                    
                        <div className="filter_controll">   
                                    <label>Dziecko: </label>                             
                                    <InputTextAlpha   userData={props.userData} value={filterParam.d_imie_nazwisko}   valChange={valChangeListener} goNext={goNextNew} name="d_imie_nazwisko" placeholder={"Dziecko: "}   />
                        </div>  

                        <div className="filter_controll">   
                                    <label>Rodzic: </label>                             
                                    <InputTextAlpha   userData={props.userData} value={filterParam.r_imie_nazwisko}   valChange={valChangeListener} goNext={goNextNew} name="r_imie_nazwisko" placeholder={"Rodzic: "}   />
                        </div> 
    


                        <div className="filter_controll filter_merge">   
                                <label>Data (od dnia / do dnia): </label>      <br/>                       
                                <InputDate   userData={props.userData} value={filterParam.data_od}   valChange={valChangeListener} goNext={goNextNew} name="data_od" placeholder={"Od dnia: "}   />                                                                  
                                <InputDate   userData={props.userData} value={filterParam.data_do}   valChange={valChangeListener} goNext={goNextNew} name="data_do" placeholder={"Do dnia: "}   />
                    </div> 

                        
                          
                        <div className="filter_controll filter_merge">   
                            <label>Kwota (od / do): </label>        
                            <br/>                     
                            <InputDecimal   userData={props.userData}  mainView={props.mainView}  value={filterParam.kwota_od}   valChange={valChangeListener} goNext={goNextNew} name="kwota_od" placeholder={" "}   />
                            <InputDecimal   userData={props.userData}  mainView={props.mainView}  value={filterParam.kwota_do}   valChange={valChangeListener} goNext={goNextNew} name="kwota_do" placeholder={" "}   />
                        </div> 

    


                                <div className="filter_btn">
                                    <span className="link_color" onClick={filterView}>&nbsp;ukryj filtry&nbsp;</span> 
                                    <span className="btn" onClick={filterApprove} >filtruj</span>&nbsp;&nbsp;<span className="btn" onClick={filterClear} >wyczyść</span>
                                </div>
                        </div>
                } 



                          


                                <div className="table_widget">
                                            <InputPagger filter={filterParam}  onChange={onChangePagger}  />
                                            
                                            <InputLegend items={legend}/>

                                            &nbsp; &nbsp;
                                            <HtmlToPDF tabRef={tabRef} userData={props.userData} mainView={props.mainView}  orientation="landscape" title="Rozliczenia" />   
                                            <Csv tabRef={tab2Ref} title="Rozliczenia.csv"/>                  
                                            <Xlsx tabRef={tab2Ref} title="Rozliczenia.xlsx" />                  
                                            <Print tabRef={tab2Ref} />

                                            <SortBy  cols={sortList} param={filterParam.sortBy}  onChange={onChangeSortBy}  />  
                                </div>


                                <div className="table_mass">  
                                    <div className="title_mass">Operacje masowe (zaznaczono: {zaznaczonych}) </div>
                                    &nbsp;

                                    <InvoiceSplit userData={props.userData} mainView={props.mainView} selected={arrSelectedToRem} onSuccess={getTab}  />
                                    &nbsp; &nbsp;
                                    <CalculateTrans userData={props.userData} mainView={props.mainView} selected={arrSelectedToRem2} onSuccess={getTab}  />
                                </div>

            

                                <div className="gohide" ref={tabRef}>
                                                <h3>Rozliczenia</h3>  

                                                <table className="table" ref={tab2Ref} >
                                                    <thead>
                                                        <tr className="header">                                                                                                       
                                                            <td>LP</td>  
                                                            <td>Typ</td>                                                                                                                           
                                                            <td>Subkonto</td>
                                                            <td>Rodzic</td>                                                                                                                             
                                                            <td>Dziecko</td>                                                                                                                             
                                                            <td>Opis</td>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  
                                                            <td>Kwota</td>                                                                                                                             
                                                            <td>Kwota rozliczenia</td>                                                                                                                             
                                                            <td>Pozostało</td>                                                                                                                             
                                                                                                                                                                                                                                                                                          
                                                        </tr>
                                                    </thead>
                                                    <tbody>

                                                        {
                                                            tab.map( (row, ix) => {

                                                                var strTyp = "?";

                                                                

                                                                if(row.strona == 'ma') 
                                                                {
                                                                        if(row.typ == 'p_przelewy')
                                                                        {
                                                                            strTyp = "[MA] | Przelew";
                                                                        }

                                                                        if(row.typ == 'f_faktura')
                                                                        {
                                                                            strTyp = "[MA] Faktura /" + row.tsubkonto.nazwa;
                                                                        }

                                                                        if(row.typ == 'f_faktura_ods')
                                                                        {
                                                                            strTyp = "[MA] Odsetki";
                                                                        }
                                                                }

                                                                if(row.strona == 'wn') 
                                                                {
                                                                       if(row.typ == 'p_przelewy')
                                                                        {
                                                                            strTyp = "[WN] Zwrot";
                                                                        }

                                                                        if(row.typ == 'f_faktura')
                                                                        {
                                                                            strTyp = "[WN] Faktura";
                                                                        }

                                                                        if(row.typ == 'f_faktura_ods')
                                                                        {
                                                                            strTyp = "[WN] Odsetki";
                                                                        }
                                                                }

                                                                HrazemKwota = parseFloat(HrazemKwota) + parseFloat(row.kwota);
                                                                HrazemKwotaRozliczenia = parseFloat(HrazemKwotaRozliczenia) + parseFloat(row.kwota_rozliczenia);
                                                                HrazemPozostalo = parseFloat(HrazemPozostalo) + parseFloat(row.pozostalo);

                                                                return <tr className="row">
                                                                            <td>{ix+1}</td>                                                                                                                             
                                                                            <td className="gocenter gobold">{strTyp}</td>                                                                                                   
                                                                            <td className="gocenter">{row.subkonto.nazwa + " " + row.subkonto.numer_konta} </td>                                 
                                                                            <td>{row.rodzic.nazwisko + " " + row.rodzic.imie}</td>                                                                                                                             
                                                                            <td>{row.dziecko.nazwisko + " " + row.dziecko.nazwisko}</td>                                                                                                                             
                                                                            <td>{row.opis}</td>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                            <td className="goright"><FormatDecimal value={row.kwota} /></td>                                                                                                                             
                                                                            <td className="goright"><FormatDecimal value={row.kwota_rozliczenia} /></td>                                                                                                                             
                                                                            <td className="goright"><FormatDecimal value={row.pozostalo} /></td>                                                                                                                                                                                              
                                                                     </tr>

                                                            } )
                                                        }

                                                                        <tr className="row">
                                                                            <td> </td>                                                                                                                             
                                                                            <td className="gocenter gobold">  </td> 
                                                                            <td className="gocenter"> </td>                                 
                                                                            <td>   </td>                                                                                                                             
                                                                            <td> </td>                                                                                                                             
                                                                            <td> </td>                                                                                                                             
                                                                            <td className="gobold">Razem</td>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                            <td className="goright gobold"><FormatDecimal value={HrazemKwota} /></td>                                                                                                                             
                                                                            <td className="goright gobold"><FormatDecimal value={HrazemKwotaRozliczenia} /></td>                                                                                                                             
                                                                            <td className="goright gobold"><FormatDecimal value={HrazemPozostalo} /></td>                                                                                                                                                                                              
                                                                     </tr>

                                                    </tbody>

                               </table>

                                </div>

                        <div className="scorll_x">
                                <table className="table" >
                                                    <thead>
                                                        <tr className="header">    
                                                           <td className="link_normal td_left" onClick={changeSelectedAll}>Z</td>                                                                                                       
                                                            <td>LP</td>  
                                                            <td>Typ</td>                                                                                                                           
                                                            <td>Subkonto</td>
                                                            <td>Dziecko</td> 
                                                            <td>Rodzic</td>                                                                                                                                                                                                                                                                                                                    
                                                            <td>Data</td> 
                                                            <td>Opis</td>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              
                                                            <td>Kwota</td>                                                                                                                             
                                                            <td>Kwota rozliczenia</td>                                                                                                                             
                                                            <td className="td_right">Pozostało</td>                                                                                                                             
                                                            <td className="td_btn_option"> </td>                                                                                                                             
                                                                                                                                                                                                                                                                                          
                                                        </tr>
                                                    </thead>
                                                    <tbody>

                                                        {
                                                            tab.map( (row, ix) => {

                                                                var strTyp = "?";

                                                                var cssRow = "";

                                                                if(row.pozostalo == 0) cssRow = "color_show2";


                                                                if(row.strona == 'ma') 
                                                                {
                                                                        if(row.typ == 'p_przelewy')
                                                                        {
                                                                            strTyp = "[MA] | Przelew";
                                                                        }

                                                                        if(row.typ == 'f_faktura')
                                                                        {
                                                                            strTyp = "[MA] Faktura /" + row.tsubkonto.nazwa;
                                                                        }

                                                                        if(row.typ == 'f_faktura_ods')
                                                                        {
                                                                            strTyp = "[MA] Odsetki";
                                                                        }
                                                                }

                                                                if(row.strona == 'wn') 
                                                                {
                                                                       if(row.typ == 'p_przelewy')
                                                                        {
                                                                            strTyp = "[WN] Zwrot";
                                                                        }

                                                                        if(row.typ == 'f_faktura')
                                                                        {
                                                                            strTyp = "[WN] Faktura";
                                                                        }

                                                                        if(row.typ == 'f_faktura_ods')
                                                                        {
                                                                            strTyp = "[WN] Odsetki";
                                                                        }
                                                                }

                                                                razemKwota = parseFloat(razemKwota) + parseFloat(row.kwota);
                                                                razemKwotaRozliczenia = parseFloat(razemKwotaRozliczenia) + parseFloat(row.kwota_rozliczenia);
                                                                razemPozostalo = parseFloat(razemPozostalo) + parseFloat(row.pozostalo);

                                                                var rowStyle = " row ";
                                                                if(ix % 2 == 0 )rowStyle = " row2 ";


                                                                var isChecked = "";

                                                                for(var s=0; s<selectedRow.length; s++)
                                                                    {
                                                                        if( selectedRow[s].id == row.id &&  selectedRow[s].selected == 1) isChecked = "checked";
                                                                    }


                                                                return <tr className={ rowStyle + cssRow}>

                                                                            <td className="td_right">
                                                                                <input type="checkbox" atr-id={row.id} onChange={changeSelected} checked={isChecked} />
                                                                            </td>   

                                                                            <td>{ix+1}</td>  

                                                                            <td className="gocenter">{strTyp}</td>                                                                                                   
                                                                            <td className="gocenter">{row.subkonto.nazwa + " " + row.subkonto.numer_konta} </td>                                 
                                                                            <td>
                                                                                {row.dziecko.nazwisko + " " + row.dziecko.imie}
                                                                                <img src={gopresent} id={row.dziecko.id} imie={row.dziecko.imie} nazwisko={row.dziecko.nazwisko} onClick={reviewKid} title="podgląd"  />   
                                                                                <img src={search} className="small_tip_img" title="Pokaż tylko to dziecko"  search={row.dziecko.nazwisko + " " + row.dziecko.imie} onClick={searchKid} />
                                                                            </td> 
                                                                            <td>
                                                                                {row.rodzic.nazwisko + " " + row.rodzic.imie}
                                                                                <img src={search} className="small_tip_img" title="Pokaż tylko tego rodzica"  search={row.rodzic.nazwisko + " " + row.rodzic.imie} onClick={searchParent} />
                                                                            </td>                                                                                                                                                                                                             
                                                                            <td>{row.data}</td>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                            <td>{row.opis}</td>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                            <td className="goright link_normal" onClick={changeView} v="edit" id={row.id}><FormatDecimal value={row.kwota} /></td>                                                                                                                             
                                                                            <td className="goright link_normal" onClick={changeView} v="edit" id={row.id}><FormatDecimal value={row.kwota_rozliczenia} /></td>                                                                                                                             
                                                                            <td className="goright link_normal"  onClick={changeView} v="edit" id={row.id} ><FormatDecimal value={row.pozostalo} /></td>     
                                                                            <MenuTable>
                                                                                <ul>
                                                                                    <li  onClick={changeView} v="edit" id={row.id} >szczegóły </li>
                                                                                    {
                                                                                        row.pozostalo > 0 && row.rozdzielone_z_p_saldo_ma_wn_id < 1 &&
                                                                                        <li  onClick={changeView} v="move" id={row.id} >przenieś</li>
                                                                                    }

                                                                                    {
                                                                                        row.pozostalo == 0 && row.rozdzielone_z_p_saldo_ma_wn_id > 0 &&
                                                                                        <li  onClick={moveBack}   id={row.id} >cofnij przeniesienie</li>
                                                                                    }
                                                                                 
                                                                                </ul>
                                                                            </MenuTable>                                                                                                                                                                                         
                                                                                                                                                                                                                                                                      
                                                                     </tr>

                                                            } )
                                                        }

                                                                        <tr className="row">
                                                                            <td> </td>                                                                                                                             
                                                                            <td className="gocenter gobold"> &nbsp; </td> 
                                                                            <td className="gocenter"> &nbsp; </td>                                 
                                                                            <td> &nbsp; </td>                                                                                                                             
                                                                            <td> &nbsp; </td>                                                                                                                             
                                                                            <td>&nbsp; </td>                                                                                                                             
                                                                            <td>&nbsp; </td>                                                                                                                             
                                                                            <td className="gobold">Razem</td>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                            <td className="goright gobold"><FormatDecimal value={razemKwota} /></td>                                                                                                                             
                                                                            <td className="goright gobold"><FormatDecimal value={razemKwotaRozliczenia} /></td>                                                                                                                             
                                                                            <td className="goright gobold"><FormatDecimal value={razemPozostalo} /></td>                                                                                                                                                                                              
                                                                            <td> </td>                                                                                                                                                                                              
                                                                     </tr>

                                                    </tbody>

                               </table>
                        </div>


                </div>



  
    </div>

}



export default Calculate;



